import { render, staticRenderFns } from "./CookieNotice.vue?vue&type=template&id=ccd228d8&scoped=true"
import script from "./CookieNotice.vue?vue&type=script&lang=js"
export * from "./CookieNotice.vue?vue&type=script&lang=js"
import style0 from "./CookieNotice.vue?vue&type=style&index=0&id=ccd228d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd228d8",
  null
  
)

export default component.exports